import React from 'react'
import '../styles/Header.css'

export default function Header() {
  return (
    <div className='header-component' >
      <h2>
        A simple clock app, made using React! 😎❤️
      </h2>
    </div>
  )
}
